import React, {Component} from 'react';
import styled from 'styled-components'

export const LoginButton = styled.button`
border: #ffffff solid 3px;
width: 80%;
max-width: 600px;
background-color: rgba(255,255,255, 0.4);
color: white;
font-size: 1.5rem;
padding: .2rem 1.2rem;
font-family: Quicksand, sans-serif;
text-transform: uppercase;
border-radius: 10px;
font-weight: 600;
`
